import native from '@zz-common/native-adapter'

/**
 * 登录函数装饰器
 *
 * @param target 目标对象
 * @param funcName 函数名
 * @param descriptor 函数描述符
 * @param args 参数列表
 */

export function login(target, funcName, descriptor) {
  const oriFunc = descriptor.value
  descriptor.value = async function () {
    if (native.isLogin()) {
      return oriFunc.call(this, ...arguments)
    } else {
      return await new Promise((resolve, reject) => {
        native.login({
          // needReplaceLocation: true,
          callback: (res) => {
            if (parseInt(res.code) === 0) {
              resolve(oriFunc.call(this, ...arguments))
            } else {
              reject(res)
            }
          }
        })
      }).catch(() => {
        //ignore
      })
    }
  }
}
